export default "__VITE_ASSET__BaALyL5h__"